import React from 'react';
export default function IconWihTextOnTheRight(_ref) {
  let {
    icon,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, icon), " ", text);
}